import Star from '@mui/icons-material/Star';
import React from 'react';

import ModalDemoQuickAction from './modal-demo';
import WizardDialogQuickAction from './wizard-dialog-quick-action';

import {
  QuickActionButton,
  QuickActionDrawer,
} from '~/client/components/base/quick-action';

interface Props {
  className?: string;
}

const QuickActionDemo: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <QuickActionDrawer header={{ text: 'QUICK ACTIONS' }}>
        <WizardDialogQuickAction />
        <ModalDemoQuickAction />
        <QuickActionButton icon={Star}>New proposal</QuickActionButton>
        <QuickActionButton icon={Star}>Start review</QuickActionButton>
        <QuickActionButton icon={Star}>
          Example long text with many words
        </QuickActionButton>
        <QuickActionButton icon={Star} disabled>
          Disabled
        </QuickActionButton>
      </QuickActionDrawer>
    </div>
  );
};

export default QuickActionDemo;
